export type Platform = 'ios' | 'android' | 'other';

/** iOS (iPhone/iPod/iPad, or iPadOS posing as "Macintosh" with touch), Android, else "other". */
export function detectPlatform(): Platform {
  try {
    const ua = navigator.userAgent || '';
    if (/iPhone|iPod|iPad/i.test(ua)) return 'ios';
    if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
    if (/Android/i.test(ua)) return 'android';
  } catch {
    // ignore
  }
  return 'other';
}

export const isPhonePlatform = (p: Platform): boolean => p === 'ios' || p === 'android';
